import { IsNotEmpty, IsOptional } from "class-validator";

import { IBreedJudge } from "./breed-judge.interface";

export class BreedJudgeDto implements IBreedJudge {
  @IsNotEmpty()
  breed: string;

  @IsNotEmpty()
  judge_name: string;

  @IsOptional()
  judge_number?: string;
}
